module.exports = __webpack_public_path__ + "img/length.c415c241.svg";